import * as SVG from "@/svgs";
import { sanitize } from "@/utils/sanitize";
import { SvgProps, SvgSelectorProps } from "@/utils/types";
import { ComponentType } from "react";

export const SvgSelector = (props: SvgSelectorProps) => {
  const iconName = props.name ? sanitize(props.name) : "Apple";

  const IconComponent = SVG[
    iconName as keyof typeof SVG
  ] as ComponentType<SvgProps>;

  return <IconComponent {...props} />;
};
